import { type ComponentProps, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

interface Props extends ComponentProps<'div'> {
  maxWidth?: string
}

export function AuthCard ({ className, maxWidth = 'max-w-105', children, ...props }: Props): ReactElement {
  return (
    <div
      className={cn(
        maxWidth,
        'w-full bg-white/[0.93] backdrop-blur-lg rounded-2xl p-9 border border-white/70 shadow-[0_24px_60px_rgba(0,0,0,0.35)]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
